import styled from "styled-components";
import { ButtonPrimaryInternal } from "../Primary";
import { ButtonHoC } from "../button.js";
export const ButtonToggleInternal = styled.span`
  margin: 2px;
  align-items: center;
  border: 0;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  ${props => props.theme.fonts.default}
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  outline: 0;
  padding: 9px 12px;
  text-align: center;
  width: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  background-color: ${props => props.active ? props.theme.colors.action : props.theme.colors.buttonToggleDisabled};
  color: ${props => props.active ? props.theme.colors.white : props.theme.colors.text};
  padding: 9px 12px;
  text-align: center;
  min-width: 40px;

  &:hover {
    color: ${props => props.active ? props.theme.colors.white : props.theme.colors.action};
    svg path {
      fill: ${props => props.active ? props.theme.colors.white : props.theme.colors.action};
    }
  }
`;
export const ButtonToggle = ButtonHoC(ButtonToggleInternal);
export const ButtonToggleSmallInternal = styled(ButtonToggleInternal)`
  min-width: 84px;
`;
export const ButtonToggleSmall = ButtonHoC(ButtonToggleSmallInternal);